export var createComponentOverrides = function (creator) { return creator; };
